import { Capacitor } from '@capacitor/core'
import { NativePlugins } from 'features/NativePlugins'
import { Company } from 'interfaces'

const authenticationService = {
  canRequestNotifications,
  registerForPushNotifications,
  setupNotificationListener,
  getNotificationToken,
  subscribeTo,
  unsubscribeFrom
}

function canRequestNotifications(): boolean {
  const platform = Capacitor.getPlatform()
  return platform === 'ios' || platform === 'android'
}

async function registerForPushNotifications(): Promise<void> {
  await NativePlugins.NotificationPlugin.askForPermission()
}

async function getNotificationToken(): Promise<void> {
  // TODO: Send to backend when it is ready to handle it.
  const token = await NativePlugins.NotificationPlugin.getToken()
  console.log('Notification token: ', token)
}
function subscribeTo(channels: Company[]): Promise<string>[] {
  const topics: string[] = channelsToTopics(channels)
  topics.push('alvik-basket_game_score')
  let work = topics.map(async (topic: string) => {
    await NativePlugins.NotificationPlugin.subscribeToTopic({ topic })
    return topic
  })
  return work
}
function unsubscribeFrom(channel: Company[]) {
  const topics: string[] = channelsToTopics(channel)
  topics.push('alvik-basket_game_score')
  let work = topics.map(async (topic: string) => {
    await NativePlugins.NotificationPlugin.unsubscribeFromTopic({ topic })
    return topic
  })
  return work
}

function setupNotificationListener() {
  // This is not typed in a good way
  return NativePlugins.NotificationPlugin.addListener(
    'remote_notification',
    (event) => {
      if (!event) {
        throw new Error('No event')
      }

      try {
        const data = event.data as any
        const payload = JSON.parse(data.payload)

        // We need to validate the incoming data at some point, currently we assume it exists.
        if (payload.type === 'game_score') {
          window.location.href = `/${payload.channel}/games/g/${payload.game.ident}`
        }
      } catch (error) {
        console.error(
          'Failed to parse remote notification data, error: ',
          error,
          ', data: ',
          event.data
        )
      }
    }
  )
}

function channelsToTopics(channels: Company[]): string[] {
  return channels.map((channel: Company) => {
    const root_subdomain = channel.root_channel
      ? channel.root_channel.subdomain
      : undefined
    const channel_subdomain = channel.subdomain
    // TODO: Add more topics depending on user settings.
    return (
      (root_subdomain ? root_subdomain + '_' : '') +
      channel_subdomain +
      '_game_score'
    )
  })
}

export default authenticationService
